import { cn } from '@restworld/utils-common';
export const HeaderWrapper = ({
  isModal = true,
  className,
  ...props
}: { isModal?: boolean } & React.HTMLAttributes<HTMLDivElement>) => (
  <div className={cn('flex flex-col items-center gap-1.75', !isModal && 'w-full items-start', className)} {...props} />
);
